import { Component, OnDestroy } from '@angular/core';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { DashboardClaim, Guid } from '@lsq-frontend/remote-services/enterprise/common';
import { forLifeOf, LifecycleAware } from '@lsq-frontend/common-ui';
import { ClaimService } from '@lsq-frontend/common-ui';
import { combineLatest } from 'rxjs';
import { DashboardExperience } from '../../../constants/experience.constants';

@LifecycleAware()
@Component({
    selector: 'users-page',
    template: `
        <users [companyKey]="companyKey" [clientDashboardExperiences]="clientDashboardExperiences">
        </users>
    `
})
export class UsersPageComponent implements OnDestroy {
    public companyKey: Guid;
    public clientDashboardExperiences: DashboardExperience[] = [];

    constructor(private _userService: UserService, private _claimService: ClaimService) {
        this._userService.user$.pipe(forLifeOf(this)).subscribe((user) => {
            this.companyKey = user?.currentCompany?.companyKey;
        });

        combineLatest([
            this._claimService.isOn(DashboardClaim.FactoringDashboard),
            this._claimService.isOn(DashboardClaim.FinancingVendorPortal),
            this._claimService.isOn(DashboardClaim.FinancingBuyerPortal),
            this._claimService.isOn(DashboardClaim.FinancingAccountPortal)
        ])
            .pipe(forLifeOf(this))
            .subscribe(([isFactoringClient, isSupplier, isBuyer, isAccount]) => {
                if (isFactoringClient) {
                    this.clientDashboardExperiences.push(DashboardExperience.Factoring);
                }
                if (isSupplier) {
                    this.clientDashboardExperiences.push(DashboardExperience.SCF_Seller);
                }
                if (isBuyer) {
                    this.clientDashboardExperiences.push(DashboardExperience.SCF_Buyer);
                }
                if (isAccount) {
                    this.clientDashboardExperiences.push(DashboardExperience.SCF_Account);
                }
            });
    }

    public ngOnDestroy(): void {}
}
